import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadRoyaltyReport, exportCentralisedRoyalty } from './actions';
import { initialize } from 'redux-form';
import utils from '../../../common/services/utils';

class CentralisedRoyaltyReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const { currentYear, currentMonth } = this.props;

		const filter = { year: currentYear, month: currentMonth };
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}


	exportData(filter) {
		this.props.exportCentralisedRoyalty(filter);
	}

	render() {
		const { data, months, years, currentMonth, currentYear } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					months={months}
					years={years}
					initialValues={{ month: currentMonth, year: currentYear }}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		exports,
		lookups: { years, months },
		entities: { centralisedRoyaltyReport }
	} = state;

	const royaltyReportPagination = pagination.centralisedRoyaltyReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const centralisedRoyaltyExport = exports.centralisedRoyalty.all || {};

	return {
		data: royaltyReportPagination.ids.map(id => centralisedRoyaltyReport[id]),
		pagination: royaltyReportPagination,
		months,
		years,
		currentMonth: utils.getCurrentMonth(),
		currentYear: utils.getCurrentYear(),
		export: centralisedRoyaltyExport
	};
};

const mapDispatchToProps = {
	loadReport: loadRoyaltyReport,
	exportCentralisedRoyalty,
	resetFilter: () => reset('centralisedRoyaltyReportFilter'),
	initializeFilter: (data, fields) => initialize('centralisedRoyaltyReportFilter', data, fields)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CentralisedRoyaltyReport));